function sort(a, b) {
  if (a.label === b.label) {
    return 0;
  }

  return (a.label < b.label) ? -1 : 1;
}

function alphasort_options(items) {
  items.sort(sort);

  return items;
}

module.exports = alphasort_options;



// WEBPACK FOOTER //
// ./src/libs/twig/alphasort_options/index.js